<template>
  <div class="container">
    <b-row style="margin: 150px 0">
      <b-col>
        <div>Grades</div>
        <div>
          <router-link to="/products/grades">
            <img src="@/assets/images/img_grade.jpg" />
          </router-link>
        </div>
      </b-col>
      <b-col
        ><div>Degraus</div>
        <div><img src="@/assets/images/img_degrau.jpg" /></div
      ></b-col>
      <b-col
        ><div>Gradis</div>
        <div><img src="@/assets/images/img_gradil.jpg" /></div
      ></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Products",
};
</script>
